import { ApartmentOutlined } from "@mui/icons-material";
import { Card, CircularProgress } from "@mui/material";
import { isEmpty, isNil } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import Flx from "../../../components/layout/Flx";
import SidebarAddEntityButton from "../../../components/sidebars/DashboardSidebar/buttons/SidebarAddEntityButton";
import Txt from "../../../components/typography/Txt";
import EmptyStateCard from "../../../components/ui/EmptyStateCard";
import ProfileSection from "../components/ProfileSection";

import { DASHBOARD_SIDEBAR_TYPES } from "../../../components/sidebars/DashboardSidebar/DashboardSidebar";
import AssociatedBorrowerEntitiesTable from "../../../components/tables/AssociatedBorrowerEntitiesTable";
import { sidebarOpen } from "../../../redux/reducers/sidebarReducer";

const AssociatedEntitiesSection = ({ activeTab, setShowPreview }) => {
  const profile = useSelector((state) => state?.profile);

  const entities = profile?.associatedEntities || [];

  return (
    <ProfileSection
      activeTab={activeTab}
      title={`Associated LLC's & Entities`}
      icon={<ApartmentOutlined className="thin" />}
      endContent={isEmpty(entities) ? null : <SidebarAddEntityButton />}
    >
      <Txt secondary>
        Please give details about past experienced LLCs that you have used,
        including percentage agreements. We may ask for information or documents
        showing you are related to these entities. If you have those things
        handy, please upload them now. Examples can include operating agreements
        or proof of past experience like HUDs that you signed as guarantor.
      </Txt>
      <ContentRenderer />
    </ProfileSection>
  );
};

const ContentRenderer = () => {
  const profile = useSelector((state) => state?.profile);
  const dispatch = useDispatch();
  const entities = profile?.associatedEntities || [];

  if (isNil(profile)) {
    return (
      <Card sx={{ py: 3 }}>
        <Flx g={2} center fw column>
          <CircularProgress size={18} />
          <Txt secondary>Getting your profile information...</Txt>
        </Flx>
      </Card>
    );
  }

  if (isEmpty(entities)) {
    return (
      <EmptyStateCard
        title={"No Entities Found"}
        description={
          "Add LLCs and other entities you've used for real estate investments, including ownership details and supporting documentation."
        }
        buttonText={"Add Entity"}
        onClick={() =>
          dispatch(sidebarOpen(DASHBOARD_SIDEBAR_TYPES.ADD_ENTITY))
        }
      />
    );
  }

  if (!isEmpty(entities)) {
    return (
      <AssociatedBorrowerEntitiesTable
        onRowClick={(data) =>
          dispatch(sidebarOpen(DASHBOARD_SIDEBAR_TYPES.EDIT_ENTITY, data))
        }
        entities={entities}
      />
    );
  }

  return null;
};

export default AssociatedEntitiesSection;
